import React, {useEffect, useState} from 'react';
import SelectInput from "@/Shared/SelectInput";
import {usePrevious} from "react-use";
import {Inertia} from "@inertiajs/inertia";
import {usePage} from "@inertiajs/inertia-react";

const PaginateCount = () => {
  const { filters } = usePage().props;
  const [paginateCount, setPaginateCount] = useState(filters.paginate || 15);

  const handleChange = (e) => {
    setPaginateCount(e.target.value);
  }

  const prevValues = usePrevious(paginateCount);

  useEffect(() => {
    // https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
    if (prevValues) {
      Inertia.get(route(route().current()), {paginate: paginateCount}, {
        replace: true,
        preserveState: true
      });
    }
  }, [paginateCount]);

  return (
    <SelectInput
      label="Disp per Page"
      name="paginate"
      className={'grid grid-cols-2 gap-2 text-center'}
      labelClassName={'form-label flex items-center'}
      value={paginateCount}
      onChange={handleChange}
    >
      <option value="15">15</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </SelectInput>
  );
};

export default PaginateCount;
